/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Copy, BodyCopy, Button } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/requestratingwidget/requeststatus/requeststatus_styles';



/* ========== ~~~~~~~~~~ AUTH NEW INVITATION SENT ~~~~~~~~~~ ========== */
const NoRequest = (props) => {
    return (
        <div className={`requeststatus ${props.classes.requeststatus}`}>
            <Copy>
                <BodyCopy>
                    <div className={'title'}>Unlock No-Frills Content Rating</div>
                    <p>Enable your visitors to rate your content with Insticator’s Ratings Unit.</p>
                    <ul>
                        <li className={'norequestlistitem'}>
                            <img src={`${url.image}/icons/icon-ratings-half-filled-star.png`} />
                            <span style={{maxWidth: '257px'}}>
                            Easily add our Ratings Unit to any place in your site and allow visitors to rate from one to five stars with a tap or a click.
                            </span>
                        </li>
                        <li className={'norequestlistitem'}>
                            <img src={`${url.image}/icons/icon-ratings-graph.png`} />
                            <span style={{maxWidth: '233px'}}>Show total ratings and current average ratings on your content with the Ratings Counter.</span>
                        </li>
                    </ul>
                </BodyCopy>
                <Button text={'Request Early Access to the Ratings Unit'} variant={'primary'} type={'action'} operation={'load'} disabled={props.buttonDisabled} processing={props.requestPending} action={props.sendRequest}/>
            </Copy>
        </div>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(NoRequest);
